import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PremiumSFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.46008 5.72003L16.54 5.60003V13.0246H18.18V4.08008H5.82007V19.8401H13.1883V18.2001H7.46008V5.72003ZM17.3401 14.5247C15.8723 14.5247 14.6824 15.7146 14.6824 17.1824C14.6824 18.1575 15.2133 19.0009 15.9962 19.4633V22.5801L17.3274 21.5967L18.6585 22.5801V19.4771C19.4552 19.0182 19.9977 18.1678 19.9977 17.1824C19.9977 15.7146 18.8079 14.5247 17.3401 14.5247L17.3401 14.5247ZM17.3401 18.4001C16.6686 18.4001 16.1224 17.8538 16.1224 17.1824C16.1224 16.5109 16.6686 15.9647 17.3401 15.9647C18.0115 15.9647 18.5577 16.5109 18.5577 17.1824C18.5577 17.8538 18.0115 18.4001 17.3401 18.4001ZM14.7248 7.64008H9.27533V9.08008H14.7248V7.64008Z"
      />
    </SvgIcon>
  );
});
